import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "stores/Store";
import { setGame } from "stores/game/GameSlice";
import { setLobby } from "stores/lobby/LobbySlice";
import { isProOrHigher, PRO_FEATURES_ENABLED } from "interfaces/user";
import { openCheckout } from "utils/stripe";

import drafterLogo from "styles/images/drafterWhiteLogo.png";
import gameIcon from "styles/images/components/navbar/gameIcon.svg";
import labIcon from "styles/images/components/navbar/labIcon.svg";
import leaderboardIcon from "styles/images/components/navbar/leaderboardIcon.svg";

// TODO Warn before leaving page
function Navbar() {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.userReducer.user);

  const showNavbar = useSelector(
    (state: RootState) => state.uiStateReducer.uiState.showNavbar,
  );
  const controls = useAnimation();

  useEffect(() => {
    if (showNavbar) {
      controls.start({ left: "2%" });
    } else {
      controls.start({ left: "-20%" });
    }
  }, [showNavbar]);

  return (
    <motion.nav
      className="Navbar"
      animate={controls}
      transition={{
        ease: "easeOut",
        duration: 0.4,
        x: { duration: 1 },
        type: "spring",
      }}
      initial={{ left: "-20%" }}
    >
      <div className="navbarContainer">
        <div className="tabs">
          <NavLink
            to="/"
            className="logo"
            onClick={() => {
              dispatch(setGame(null));
              dispatch(setLobby(null));
            }}
          >
            <motion.img
              alt="DrafterGG Logo"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              src={drafterLogo}
            />
          </NavLink>
          <NavLink
            to="/lobby"
            className="icon"
            onClick={() => {
              dispatch(setGame(null));
              dispatch(setLobby(null));
            }}
          >
            <motion.img
              alt="Game Icon"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              src={gameIcon}
            />
          </NavLink>
          <NavLink
            to="/leaderboard"
            className="icon"
            onClick={() => {
              dispatch(setGame(null));
              dispatch(setLobby(null));
            }}
          >
            <motion.img
              alt="Leaderboard Logo"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              src={leaderboardIcon}
            />
          </NavLink>
          <NavLink
            to="/lab"
            className="icon labIcon"
            onClick={() => {
              dispatch(setGame(null));
              dispatch(setLobby(null));
            }}
          >
            <motion.img
              alt="Lab Icon"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              src={labIcon}
            />
          </NavLink>
        </div>
        {PRO_FEATURES_ENABLED && user && !isProOrHigher(user) && (
          <motion.button
            className="proUpgradeBtn"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={openCheckout}
          >
            PRO
          </motion.button>
        )}
        {PRO_FEATURES_ENABLED && user && isProOrHigher(user) && (
          <div className="proBadge">PRO</div>
        )}
      </div>
    </motion.nav>
  );
}

export default Navbar;
